module.exports = __webpack_public_path__ + "img/feature_import.2d0dd8d3.svg";